import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollTo = () => {
    const location = useLocation();
    const routePath = ['/personal-information', '/upload-files', '/upload-success', '/success'];
    useEffect(() => {
        if (routePath.includes(location.pathname)) {
            window.scrollTo(
                {
                    top: 76,
                    behavior: 'smooth'
                }
            );
        }
    }, [location.pathname]);

    return null;
};

export default ScrollTo;